export default {
      id: "chevron-down-usage",
      viewBox: "0 0 16 9",
      url: __webpack_public_path__ + "img/icons.ea6ea76b.svg#chevron-down",
      toString: function () {
        return this.url;
      }
    }